import Modal from "../ui-components/Modal";
import Select from "../ui-components/Select";
import Input from "../ui-components/Input";
import _ from "lodash";
import { useEffect, useState } from "react";
import Button from "../ui-components/Button";
import SearchSelect from "../ui-components/SearchSelect";

const SpreadsheetQuestionRangeModal = ({
  questions,
  spreadsheetConfigurationObject,
  updateSpreadsheetConfiguration,
  questionId,
  onExit
 }) => {

  const [questionIdState, setQuestionIdState] = useState({});
  const [selectedSheet, setSelectedSheet] = useState(null);
  const [selectedRange, setSelectedRange] = useState("");

  useEffect(() => {
    setQuestionIdState({value: questionId, label: questions.find((q)=>q.id===parseInt(questionId))?.name || null});
    setSelectedSheet(spreadsheetConfigurationObject.input_mapping[questionId]?.sheet ||
      spreadsheetConfigurationObject.sheets?.length ? spreadsheetConfigurationObject.sheets[0] : null);
  }, [questionId]);

  let sheetsOptions = spreadsheetConfigurationObject.sheets?.length ?
    spreadsheetConfigurationObject.sheets.map((s) => ({
      name: s,
      value: s
    })) : [{name: "", value: ""}];


  return (
    <Modal onExit={onExit}>
      <SearchSelect
        label={"select question"}
        value={questionIdState}
        options={questions.map((q) => ({
          label: q.name,
          value: q.id,
        }))}
        onChange={(selected) => {
          setQuestionIdState(selected);
          updateSpreadsheetConfiguration({
            ...spreadsheetConfigurationObject,
            input_mapping: {
              ...(_.omit(spreadsheetConfigurationObject.input_mapping, questionIdState.value)),
              [parseInt(selected.value)]: {sheet:selectedSheet, range:selectedRange},
            }
          })
        }}
      />
      <Select
        label={"select sheet"}
        options={sheetsOptions}
        value={spreadsheetConfigurationObject.input_mapping[questionIdState.value]?.sheet || null}
        onChange={(e) => {
          setSelectedSheet(e.target.value);
          updateSpreadsheetConfiguration({
            ...spreadsheetConfigurationObject,
            input_mapping: {
              ...spreadsheetConfigurationObject.input_mapping,
              [questionIdState.value]: {
                ...spreadsheetConfigurationObject.input_mapping[questionIdState.value],
                sheet: e.target.value,
              },
            }
          })
        }}
      />
      <Input
        label={"range"}
        value={spreadsheetConfigurationObject.input_mapping[questionIdState.value]?.range || null}
        onChange={(e) => {
          setSelectedRange(e.target.value);
          updateSpreadsheetConfiguration({
            ...spreadsheetConfigurationObject,
            input_mapping: {
              ...spreadsheetConfigurationObject.input_mapping,
              [questionIdState.value]: {
                ...spreadsheetConfigurationObject.input_mapping[questionIdState.value],
                range: e.target.value,
              },
            }
          })
        }}
      />
      <div className="mt-4 flex justify-end">
        <Button onClick={onExit}>DONE</Button>
      </div>
    </Modal>);
}

export default SpreadsheetQuestionRangeModal